import ServiceApi from "../services/services.api";

const ApiSale = {
  calculateSale: (data) => {
    const options = {
      method: "post",
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/calc/`,
    };
    return ServiceApi(options);
  },
  saveSale: (data) => {
    const options = {
      method: "post",
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/save/`,
    };
    return ServiceApi(options);
  },
  saveSaleStatus: (id, status) => {
    const options = {
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/${id}/status/${status}`,
    };
    return ServiceApi(options);
  },

  getSaleById: (id) => {
    const options = {
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/get/${id}`,
    };
    return ServiceApi(options);
  },
  getSaleList: (params, status, filter) => {
    const options = {
      method: "post",
      data: { ...params, ...filter },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },

      url: `/sale/list?status=${status}`,
    };
    return ServiceApi(options);
  },

  getSaleListShare: (filter, targetTitle, status) => {
    const options = {
      method: "post",
      data: { ...filter, targetTitle: targetTitle },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },

      url: `/sale/list/share?status=${status}`,
    };
    return ServiceApi(options);
  },

  removeSaleByID: (id) => {
    const options = {
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/remove/${id}`,
    };
    return ServiceApi(options);
  },
  removeSaleDetailByID: (id) => {
    const options = {
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/detail/remove/${id}`,
    };
    return ServiceApi(options);
  },
  getPublicSaleById: (id) => {
    const options = {
      method: "get",

      url: `/public/sale/get/${id}`,
    };
    return ServiceApi(options);
  },
  saveSignature: (data) => {
    const options = {
      method: "post",
      data: data,
      url: `/public/sale/signature/save`,
    };
    return ServiceApi(options);
  },
  saveContractSignature: (data) => {
    const options = {
      method: "post",
      data: data,
      url: `/public/sale/contract/save`,
    };
    return ServiceApi(options);
  },
  saleTagSave: (data) => {
    const options = {
      method: "post",
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
      url: `/sale/tag/save`,
    };
    return ServiceApi(options);
  },
  saleSlugChange: (id) => {
    const options = {
      method: "POST",
      url: `/sale/slug/change/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("hsb_token")}`,
      },
    };
    return ServiceApi(options);
  },
};

export default ApiSale;
